var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"titulo_app",style:(_vm.getTitular)}),_vm._m(0),_c('div',{staticClass:"fondo_app"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textura"},[_c('div'),_c('div')])
}]

export { render, staticRenderFns }